<template>
    <div class="basic" >
      <el-row style="height: 100%">
        <el-col :span="12" style="height: 100%;background-color: #FFFFFF;position:relative">
          <div style="position: absolute;top: 1rem;right: 6rem;font-size: 2.2rem;cursor: pointer;z-index: 100;" @click="resetChart">
            <i class="el-icon-refresh"></i>
          </div>
          <div ref="detailChart" class="chartStyle"></div>
<!--       <v-chart :key="chartKey" class="chartStyle"  ref="detailChart" :option = "{
                tooltip: {
                    trigger: 'axis',
                    confine: true,
                    axisPointer: {
                        type: 'cross',
                    },
                  },
                  color: colorData,
                  legend: {
                    data: legendData
                  },
                  toolbox: {
                    right: -60,
                    feature: {
                        dataZoom: {
                            show: true,
                            iconStyle:{ //不需要图标可以设置隐藏按钮
                                opacity:0
                            },
                            yAxisIndex: 'none'
                        }
                    }
                },
                dispatchAction:{
                  type:'takeGlobalCursor',
                  key:'dataZoomSelect',
                  dataZoomSelectActive:true
                },
                //   dataZoom: [{ // 这部分是dataZoom的配置
                //     show: true,
                //     type: 'inside', // 表示内置型数据区域缩放组件
                //     start: 0, // 数据窗口范围的起始百分比
                //     end: 100, // 数据窗口范围的结束百分比
                // }],
                  grid: grid,
                  xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    axisTick: {
                      alignWithLabel: true,
                    },
                    data: xAxis
                    // boundaryGap: false
                  },
                  yAxis: yAxisColumn,
                  series: seriesData
        }" ></v-chart>-->
        </el-col>
        <el-col :span="12" style="height: 100%;background-color: #FFFFFF">
          <div ref="tableDiv" class="tableDiv">
            <el-table
                :key="chartKey"
              :data="tableData"
              height="calc(100% - 1rem)"
              border
              size="small"
                :header-cell-style="{textAlign:'center'}"
              v-loading="loading"
              element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading"
              >
              <el-table-column
                  property="mpcd"
                  label="测点编号"
                  align="center"
                  min-width="110"
              >
              </el-table-column>
            <el-table-column
                property="mstm"
                label="测量时间"
                align="center"
                min-width="160"
            >
            </el-table-column>

              <el-table-column
                  v-for="(item,index) in columns"
                  :key="item.property+'-'+index"
                  :property="item.property"
                  :label="item.label"
                  :min-width="item.width"
              >
                <template slot-scope="scope">
                   <span :style="{'width':'100%','display': 'flex','justify-content':'flex-end','color': scope.row[item.property] ?
                    item.trend ?
                      scope.row[item.trend] ?
                      scope.row[item.trend] > 0 ?
                      '#fd1553' :
                      scope.row[item.trend] < 0 ?
                      '#15bffd' : '#000' : '#000'
                      :'#000'
                      :'#000'}"
                   >{{ scope.row[item.property] ? scope.row[item.property] : '' }}</span>
                </template>
              </el-table-column>

            </el-table>
          </div>
          <div class="pageStyle">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handlePageChange"
                :page-sizes="[20, 30, 40, 50, 100]"
                :page-size="params.size"
                :current-page="params.current"
                layout="total, prev, pager, next,sizes, jumper"
                :total="total"
            >
            </el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>
</template>
<script setup>
/*
import VChart from "vue-echarts";
import {use} from "echarts/core";
import {LineChart} from "echarts/charts";
import {CanvasRenderer} from "echarts/renderers";
// import {takeGlobalCursor } from "echarts/t"
import "echarts/lib/component/dataZoom";
import {GridComponent, LegendComponent, ToolboxComponent, TooltipComponent,} from "echarts/components";
*/


// const types = {'PZWL':'0601','SPPR': '0602','ST':'0603','SRHRDS':'0604','SRVRDS':'0605'};

/*use([
  CanvasRenderer,
  GridComponent,
  TooltipComponent,
  LineChart,
  ToolboxComponent,
  LegendComponent,
]);*/
  export default {
    name:'detail',
    data() {
      return {
        grid:{},
        mpcd: '',
        chartKey: 0,
        tableKey: 0,
        tableData: [],
        dateTime: [],
        columns: [],
        // tableMaxHeight: 0,
        type: '',
        xAxis: [],
        detailChart: null,
        /*colorData:[],
        legendData:[],
        seriesData: [
          {
            name: '数值（m³/h）',
            type: 'line',
            yAxisIndex: 0,
            data: [],
            smooth: true,
            showSymbol: false, //去除面积图节点圆
          },
        ],*/
        params:{current: 1,size: 20},
        total: 0,
        // yAxisColumn: [
        //   {
        //     type: 'value',
        //     name: '数值',
        //     position: 'left',
        //   }
        // ],
        loading: false,
        option: {}
      }
    },
    mounted(){

    },
    methods: {
      resetChart(){
        this.detailChart.dispatchAction({
          type: 'restore',
        });
        this.detailChart.setOption(this.option);
        this.detailChart.dispatchAction({
          type:'takeGlobalCursor',
          key:'dataZoomSelect',
          dataZoomSelectActive:true
        });

      },
      reset(){
        // this.tableData = [];
       /*this.seriesData = [
          {
            name: '数值（m³/h）',
            type: 'line',
            yAxisIndex: 0,
            data: [],
            smooth: true,
            showSymbol: false, //去除面积图节点圆
          },
        ];
       this.yAxisColumn= [
          {
            type: 'value',
            name: '数值',
            position: 'left',
          }
        ];*/
      },
      addResize(){
        window.addEventListener("resize", this.onWindowResize, false);
      },
      cancelResize(){
        window.removeEventListener("resize",this.onWindowResize);
      },
      handlePageChange(page){
        this.params.current = page;
        this.loading = true;
        this.queryData(this.type,this.mpcd,this.dateTime,this.changLoading);
      },
      handleSizeChange(size){
        this.params.size = size;
        this.loading = true;
        this.queryData(this.type,this.mpcd,this.dateTime,this.changLoading);
      },
      changLoading(loading){
        this.loading = loading;
      },
      initChartYAxis(columns,datas){
        const ys = [];
        const seris = [];
        let i = 0;
        const colors = [];
        const legends = [];

        for(let col of columns){
          if(!col.needChart){
            continue;
          }
          let offset = 0;
          if(col.offset){
            offset = col.offset;
          }
          colors.push(col.lineColor);
          legends.push(col.label + col.dw);

          const yAxis = {
                type: 'value',
                name: col.label,
                position: col.yPosition,
                alignTicks: true,
                offset: offset,
                axisLine: {
                  show: true,
                  lineStyle: {
                    color: col.lineColor,
                  },
                },
                axisLabel: {
                  formatter: '{value}',
                },
              };
          ys.push(yAxis);
          let data = [];
          if(datas && datas[col.bh]){
            data = datas[col.bh];
          }
          const seri = {
                name: col.label,
                type: col.chartType,
                yAxisIndex: i,
                data: data,
                lineStyle:{
                  color: col.lineColor,
                },
                areaStyle: {
                  color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: col.lineColor,
                      },
                      {
                        offset: 1,
                        color: col.lineColorStop,
                      },
                    ],
                    global: false,
              },
            },
                smooth: true,
                showSymbol: false, //去除面积图节点圆
              };
          seris.push(seri);
          i++;
        }
        // this.yAxisColumn = ys;
        // this.seriesData = seris;
        // this.colorData = colors;
        // this.legendData = legends;

        const options = {
          tooltip: {
            trigger: 'axis',
            confine: true,
            axisPointer: {
              type: 'cross',
            },
          },
          color: colors,
          legend: {
            data: legends
          },
          toolbox: {
            right: -60,
            feature: {
              dataZoom: {
                show: true,
                // icon:{
                //   back: ''
                // },
                iconStyle:{ //不需要图标可以设置隐藏按钮
                  opacity:0
                },
                yAxisIndex: 'none'
              }
            }
          },
          dispatchAction:{
            type:'takeGlobalCursor',
            key:'dataZoomSelect',
            dataZoomSelectActive:true
          },
          //   dataZoom: [{ // 这部分是dataZoom的配置
          //     show: true,
          //     type: 'inside', // 表示内置型数据区域缩放组件
          //     start: 0, // 数据窗口范围的起始百分比
          //     end: 100, // 数据窗口范围的结束百分比
          // }],
          grid: this.grid,
          xAxis: {
            type: 'category',
            boundaryGap: false,
            axisTick: {
              alignWithLabel: true,
            },
            data: this.xAxis
            // boundaryGap: false
          },
          yAxis: ys,
          series: seris
        };
        this.option = options;
        this.detailChart.setOption(options);
        this.detailChart.dispatchAction({
          type:'takeGlobalCursor',
          key:'dataZoomSelect',
          dataZoomSelectActive:true
        })
        // this.chartKey++;
        // this.$refs.detailChart.dispatchAction({
        //   type:'takeGlobalCursor',
        //   key:'dataZoomSelect',
        //   dataZoomSelectActive:true
        // })
      },
     /* changeCondition(mpcd,dateTime){
        this.mpcd = mpcd;
        this.dateTime = dateTime;
      },*/
      /*clearData(){
        this.colorData = [];
        this.
      },*/
      changeMpcd(mpcd){
        this.mpcd = mpcd;
      },
      changeTime(time){
        this.dateTime = time;
      },
      initCondition(columns,type,mpcd,dateTime,grid){
     /* initCondition(columns,mpnm,type,mpcd,maxHeight,dateTime){*/
        this.columns = columns;
        this.type = type;
        this.changeMpcd(mpcd);
        this.changeTime(dateTime);
        this.grid = grid;
        const chartDiv = this.$refs.detailChart;
        this.detailChart = this.$echarts.init(chartDiv);

        // this.chartKey++;
        // this.tableMaxHeight = maxHeight ;
        // this.tableMaxHeight = tableDiv.offsetHeight;
         /* this.mpnm = mpnm;
          this.type = type;
          this.mpcd = mpcd;
          this.tableMaxHeight = maxHeight;
          this.dateTime = dateTime;

        this.queryData();*/
          // console.log(type)
          //查询测站
        // const params = {type: types[type]};
        /*this.request.get('/rm-bmp/queryMpOrStbprp',{params}).then(res =>{
          if(res.ok){
            this.mps = res.data;

          }else {
            this.$message.error(res.error.message);
          }
        });*/
          // this.calHeight();

      },
      onWindowResize(){
        // this.calHeight();
        this.chartKey++;
      },
      /*calHeight(){
        const tableDiv = this.$refs.tableDiv;
        this.tableMaxHeight = tableDiv.offsetHeight;
        this.chartKey++;
      },*/
      getDate(){
        return [this.dateTime[0].substring(0,10),this.dateTime[1].substring(0,10)];
      },
      queryData(type,mpcd,dateTime,onChange){
        const chartParams = {mstp: type,mstmGE:dateTime[0],mstmLE:dateTime[1],mpcd:mpcd};
        const params = {mstp: type,mstmGE:dateTime[0],mstmLE:dateTime[1],mpcd:mpcd,current: this.params.current,size: this.params.size};
        // this.$parent.onChange(true);
        this.request.post('/rm-rpzwl/queryMpcdSjPage',params).then((res)=> {
          if(res.ok){
              if(res.data) {
                console.log(res.data.records)
                this.tableData = res.data.records;
                this.total = res.data.total;
                onChange(false);
              }
            }else {
              this.$message.error(res.error.message);
            }
        })
        this.request.post('/rm-rpzwl/queryQxt',chartParams).then((res)=> {
          if(res.ok){
            if(res.data) {
              this.xAxis = res.data.dtList;
              this.initChartYAxis(this.columns, res.data);
              // this.$parent.onChange(false);
            }else{
              this.xAxis = [];
              this.initChartYAxis(this.columns, null);
            }
            // this. = res.data;
          }else {
            this.$message.error(res.error.message);
          }
        })
      },
    }
}
</script>
<style scoped>
  .basic{
    width: 100%;
    height: calc(100% - 7.2rem);
  }
  .searchDate > .el-picker-panel__footer >.el-button:first-child{
    display: none;
  }
  .activeButton{
    background-color: #409EFF;
    border-color: #409EFF;
  }
  .normalButton{
    background-color: #ecf5ff;
    border-color: #b3d8ff;
    color: #409eff;
  }
  .chartStyle{
    width: 100%;
    height: 100%;
  }
  /*.chartStyle /deep/ div{
    width: 100%;
    height: 100%;
  }*/
  .pageStyle{
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
  .tableDiv{
    width: 100%;
    height: calc(100% - 3.2rem);
    /*margin-left: 2rem;*/
  }
</style>
